export const ctrlID = {
  tradeCtrl: 'trade',
  marketCtrl: 'market',
  caCtrl: 'ca',
  ipoCtrl: 'ipo',
  accountCtrl: 'accountCtrl',
  addWlCtrl: 'addWlCtrl',
  bidAskCtrl: 'bidAskCtrl',
  oneRowAccountBalanceCtrl: 'oneRowAccountBalanceCtrl'
}